export const VALID_IMAGE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
  "image/svg+xml",
] as const;

type ImageTypes = (typeof VALID_IMAGE_TYPES)[number];

const MAX_FILE_SIZE = 10; // 10MB

const MAX_FILE_SIZE_IN_BYTES = MAX_FILE_SIZE * 1024 * 1024;

export function validateImageFile(file: File): ImageTypes | false {
  if (!VALID_IMAGE_TYPES.includes(file.type as ImageTypes)) {
    const supportedFormats = VALID_IMAGE_TYPES.join(", ");
    console.warn(`Invalid MIME type ${file.type}. Supported formats: ${supportedFormats}.`);
    return false;
  }

  if (file.size > MAX_FILE_SIZE_IN_BYTES) {
    console.warn(`File size too large: ${file.size}. Image size must be under ${MAX_FILE_SIZE}MB.`);
    return false;
  }

  return file.type as ImageTypes;
}
